export const generateTicketIdentify = (ticket: {
  showId: string;
  performanceId?: number | undefined;
  zoneId: string | undefined;
  date: string;
  restaurantId?: string;
  usedArea2?: string | number;
}) => {
  let identify = ticket.showId;
  for (let key in ticket) {
    if (key === 'showId') continue;
    const value = ticket[key];
    identify += '_';
    if (value && value !== 'undefined' && value !== 'null') identify += value;
  }
  return identify;
};

export const generateTicketInfo = (
  name: string,
  date: string,
  restaurant?: string | null,
  usedArea2?: string | null,
) => {
  const ticket = {
    name,
    date,
    restaurant,
    usedArea2,
  };
  const validProperty = Object.keys(ticket).filter(key => !!ticket[key]);
  return validProperty?.reduce((result, key) => {
    if (!result) return `${ticket[key]}`;
    return `${result} - ${ticket[key]}`;
  }, '');
};
